import { safeSetLocalStorageItem } from '@mc/browser-storage'

export const LEAD_EMAIL_KEY = 'lead_email'

export const setLeadEmail = (email: string) => {
  safeSetLocalStorageItem(LEAD_EMAIL_KEY, email)

  if (typeof document !== 'undefined') {
    document.dispatchEvent(new Event('leadEmailSubmitted'))
  }
}
